export class CreateIntegrationRequest {
    'config';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "config",
            "baseName": "config",
            "type": "IntegrationConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateIntegrationRequest.attributeTypeMap;
    }
    constructor() {
    }
}
